import { AdminService } from '@naturalcycles/js-lib/browser'

export const adminService = new AdminService({
  onChange: adminMode => console.log({ adminMode }),
  onRedDotClick: () => alert('RedDot clicked'),
})

// adminService.adminMode = true
adminService.startListening()
